import React, { useContext, useCallback } from 'react';
import { IViewSubcategoryContext, ViewSubcategoryContext } from '../viewSubcategoryState/viewSubcategoryContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalAssignSubcategoryToRestaurants } from 'components/ModalWindows/ModalAssignSubcategoryToRestaurants';
import { ModalAssignDishesToSubcategory } from 'components/ModalWindows/ModalAssignDishesToSubcategory';

export const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		refetchData,
		refetchRestPropsData,
		subcategoryFullInfo,
		restaurantIdForRestaurantProps,
		typeOfModalWindow,
	} = useContext<IViewSubcategoryContext>(ViewSubcategoryContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, [refetchData, changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchRestPropsData = useCallback(() => {
		refetchRestPropsData(true);
		changeTypeOfModalWindow(null);
	}, [refetchRestPropsData, changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingSubcategory');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'errorUpdatingSubcategory' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingSubcategory"
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && (
				<ModalAssignSubcategoryToRestaurants
					onCloseModal={handleCloseModalWithRefetchData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseAssignRestaurantsModalWithError}
					subcategoryId={subcategoryFullInfo?.id || ''}
				/>
			)}
			{typeOfModalWindow === 'assignDishes' && subcategoryFullInfo && (
				<ModalAssignDishesToSubcategory
					onCloseModal={handleCloseModalWithRefetchRestPropsData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseAssignRestaurantsModalWithError}
					subcategoryID={subcategoryFullInfo.id}
					customerName={subcategoryFullInfo.customer.name || '-'}
					categoryName={subcategoryFullInfo.category.name || '-'}
					restaurantsOfSubcategory={subcategoryFullInfo.restaurants}
					restaurantIdForRestaurantProps={restaurantIdForRestaurantProps}
				/>
			)}
		</ModalWrapper>
	);
};
